import { systemStatusTypes } from '@twiliointernal/services-common/components/systemStatus';

import { getOscConfig } from '@twiliointernal/e2-commons-shared-definitions';

const { incidentStatusPage } = getOscConfig();

const LOG_PREFIX = '[System Status]';

const defaultState: systemStatusTypes.SystemStatusProps = {
  loading: true,
  loadingCount: 18,
  hasError: false,
  statusPageUrl: incidentStatusPage.twilio,
  systemStatuses: undefined,
};

const systemStatusMap: Record<string, systemStatusTypes.SystemStatusTypes> = {
  operational: systemStatusTypes.SystemStatusTypes.success,
  under_maintenance: systemStatusTypes.SystemStatusTypes.warning,
  degraded_performance: systemStatusTypes.SystemStatusTypes.warning,
  partial_outage: systemStatusTypes.SystemStatusTypes.error,
  major_outage: systemStatusTypes.SystemStatusTypes.error,
};

const constants = {
  LOG_PREFIX,
  defaultState,
  systemStatusMap,
};

export default constants;
